export default "__VITE_ASSET__BuY1jHfY__"